module.exports = __webpack_public_path__ + "media/images/front/hospitals/osaka_med_jrc-cf7085174f281edd7173d54a378ab13a.jpg";